<template>

    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                           {
                               name: $tc('messages.adverts', 2),
                               href: null
                           }
                       ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.create" element="inertia-link">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                        <tr>
                            <th class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                {{ $t('messages.name') }}
                            </th>
                            <th class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                {{ $t('messages.url') }}
                            </th>
                            <th class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                {{ $t('messages.description') }}
                            </th>
                            <th class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                {{ $t('messages.published') }}
                            </th>
                            <th class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                <span class="sr-only">{{ $t('messages.actions') }}</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :class="(index % 2 === 0) ? 'bg-white' : 'bg-gray-50'" v-for="(advert, index) in adverts.data">
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                <div>
                                    {{ advert.name }}
                                </div>
                                <div class="mt-1">
                                    <ZoomableImage :src="advert.image_path">
                                        <img
                                            :src="advert.image_path"
                                            class="w-36"
                                            :alt="advert.name"
                                        />
                                    </ZoomableImage>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                {{ advert.url }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                {{ advert.description }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                <div :class="{
                                    'text-green-500': advert.is_published,
                                    'text-gray-400': !advert.is_published
                                }">
                                    <div>
                                        {{ advert.published_at }}
                                    </div>
                                    <div>
                                        {{ advert.unpublished_at }}
                                    </div>
                                </div>
                            </td>

                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 text-right flex gap-2">
                                <InertiaSquareLinkButton action="edit" :href="advert.links.edit" />
                                <InertiaSquareDeleteButton :href="advert.links.delete" v-if="advert.can.delete"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="adverts" />
        </template>

    </PanelPage>
</template>

<script>
import CentralLayout from '@/Shared/CentralLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import AppButton from '@/components/AppButton.vue';
import ZoomableImage from '@/components/ZoomableImage.vue';

export default {
    components: {
        ZoomableImage,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        AppButton,
    },
    layout: CentralLayout,
    name: 'Index',
    props: ['meta', 'adverts', 'filters',],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
